import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CodemirrorComponent } from '@ctrl/ngx-codemirror';
import { ValuesExchangeProvider } from '../../providers/values.exchange/values.exchange.provider';
import { TimeoutWrapperService } from '../../providers/timeout.wrapper/timeout.wrapper.service';

@Component({
  selector: 'code-editor',
  templateUrl: './code-editor.component.html',
  styleUrls: ['./code-editor.component.scss']
})
export class CodeEditorComponent implements OnInit {
  @ViewChild(CodemirrorComponent) codeMirror;
  @Input() data: string;
  theme = 'default';
  options = {
    lineNumbers: true,
    theme: 'default',
    mode: 'python'
  };
  model = '';
  constructor(
    private readonly exchange: ValuesExchangeProvider,
    private readonly timeout: TimeoutWrapperService
  ) {}
  ngOnInit(): void {
    this.theme = sessionStorage.getItem('theme') === 'dark' ? 'material' : 'default';
    this.options.theme = this.theme;
    this.model = this.data;
    this.emitValue(this.model);
    this.timeout.add(() => {
      this.codeMirror.codeMirror.refresh();
    }, 500);
  }
  emitValue(event: string): void {
    this.model = event;
    this.exchange.notifyListeners('updated-code-editor', null);
    this.exchange.notifyListeners('updated-code-editor', this.model);
  }
}
